import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ATree = _resolveComponent("ATree")!

  return (_openBlock(), _createBlock(_component_ATree, _mergeProps(_ctx.$attrs, { treeData: _ctx.treeData }), null, 16, ["treeData"]))
}